<script lang="ts">
  // Much smaller than fe/src/lib/components/Footer.svelte — the support widget
  // has a single chat, so no section tabs. This is the "Powered by…" strip
  // beneath the composer. The "Tashimoto" brand is a link to tashimoto.com.
</script>

<div class="tashimoto-support-border-t tashimoto-support-bg-white tashimoto-support-px-3 tashimoto-support-py-2 tashimoto-support-flex tashimoto-support-items-center tashimoto-support-justify-end">
  <span class="tashimoto-support-text-xs tashimoto-support-text-gray-400">
    Powered by
    <a
      href="https://tashimoto.com"
      target="_blank"
      rel="noopener noreferrer"
      class="tashimoto-support-text-gray-500 hover:tashimoto-support-text-gray-700 tashimoto-support-underline"
    >Tashimoto</a>
  </span>
</div>
